import request from '@/utils/request';

export function getAllowedValuesForFieldType(query) {
	return request({
		url: '/fieldType/fetch',
		method: 'get',
		params: query,
	});
}
